import {
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
} from 'antd';
import PropTypes from 'prop-types';
import React, {useEffect} from 'react';
import toast from 'react-hot-toast';
import {useSelector} from 'react-redux';

import {
  RQPromocodeRegistrationAPI,
  RQUpdatePromocodeAPI,
} from '../../../../reactQuery/apis';
import {selectAuth} from '../../../../redux/selectors';

const {Option} = Select;

const PromocodeModal = ({open, onCancel, refetch, updatePromocodeData}) => {
  const [form] = Form.useForm();
  const auth = useSelector(selectAuth);
  const token = auth?.tokenData;

  const {mutate: registerPromocode, isLoading: isCreating} =
    RQPromocodeRegistrationAPI({
      onSuccess: () => {
        toast.success('Promocode registered successfully');
        refetch();
        onCancel();
        form.resetFields();
      },
      onError: error => {
        const errorMessage =
    error?.response?.data?.message ||  
    error?.data?.message ||             
    error?.message ||                   
    'Failed to add Brand';

        toast.error(errorMessage);
      },
    });

  const {mutate: updatePromocode, isLoading: isUpdating} =
    RQUpdatePromocodeAPI({
      onSuccess: () => {
        toast.success('Promocode updated successfully');
        refetch();
        onCancel();
      },
      onError: error => {
        toast.error(error?.message || 'Something went wrong');
      },
    });

  useEffect(() => {
    if (updatePromocodeData) {
      form.setFieldsValue(updatePromocodeData);
    } else {
      form.resetFields();
    }
  }, [updatePromocodeData, form]);

  const loading = isCreating || isUpdating;

  const handleFinish = values => {
    const payload = {
      code: values.code,
      discountValue: values.discountValue,
      isActive: values.isActive,
    };

    if (updatePromocodeData) {
      updatePromocode({
        token,
        id: updatePromocodeData.id,
        formData: payload,
      });
    } else {
      registerPromocode({
        token,
        formData: payload,
      });
    }
  };

  return (
    <Modal
      title={updatePromocodeData ? 'Update Promocode' : 'Add New Promocode'}
      open={open}
      width={600}
      centered
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={() => form.submit()}
      okText={updatePromocodeData ? 'Update' : 'Save'}
      cancelText={'Cancel'}
      okButtonProps={{
        loading,
        className: '!bg-primary-900 !text-white hover:!bg-primary-800',
      }}
    >
      <Form form={form} layout={'vertical'} onFinish={handleFinish}>
        {/* Promocode */}
        <Form.Item
          label={'Promocode'}
          name={'code'}
          rules={[{required: true, message: 'Please enter promocode'},
            {whitespace: true, message: 'Please enter promocode'},
          ]}
          getValueFromEvent={e => e.target.value.toUpperCase()} 
        >
          <Input placeholder={'Enter promocode'} />
        </Form.Item>

        {/* Discount Value */}
        <Form.Item
          label={'Discount Value'}
          name={'discountValue'}
          rules={[
            {required: true, message: 'Please enter discount value between 1 to 100'},
            {
              validator: (_, value) => {
                if (value === undefined || value === null || value === '') {
                  return Promise.resolve(); // let required rule handle empty
                }

                if (value < 1 || value > 100) {
                  return Promise.reject(
                    new Error('Discount must be between 1 and 100'),
                  );
                }

                return Promise.resolve();
              },
            },
          ]}
        >
          <InputNumber
            min={1}
            style={{width: '100%'}}
          />
        </Form.Item>

        {/* Status */}
        <Form.Item
          label={'Status'}
          name={'isActive'}
          rules={[{required: true, message: 'Please select status'}]}
        >
          <Select placeholder={'Select status'}>
            <Option value={true}>Active</Option>
            <Option value={false}>Inactive</Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

PromocodeModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  refetch: PropTypes.func.isRequired,
  updatePromocodeData: PropTypes.object,
};

export default PromocodeModal;
